<template>
	<div
		class="submissions-stats">
		<!-- Others -->
		<overviews
			:overview="overview"
			:layout="'large'"
			:items="overviewItems.others"
			:capabilities="capabilities">
		</overviews>

		<!-- Revenue -->
		<overviews
			:overview="overview"
			:layout="'large'"
			:items="overviewItems.revenue"
			:capabilities="capabilities">
		</overviews>

		<!-- Profit -->
		<overviews
			:overview="overview"
			:layout="'large'"
			:items="overviewItems.profit"
			:capabilities="capabilities">
		</overviews>

		<div class="row">
			<div class="col-sm-6">
				<div class="box box-pie-chart">
					<!-- <div class="box__title"><b>Weekly Snapshot</b></div> -->
					<div class="box__content">
						<div class="chart-title mb-3">{{ $t('Daily Transactions & Orders') }}</div>
						<transaction-chart
							class="chart"
							:chartId="transactionChartData.chartId"
							:options="transactionChartOptions"
							:chart-data="transactionChartData">
						</transaction-chart>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="box box-pie-chart text-center">
					<follow-up-conversion
						:data="followUpStats"
					/>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-6">
				<div class="box box-pie-chart">
					<!-- <div class="box__title"><b>Weekly Snapshot</b></div> -->
					<div class="box__content">
						<div class="chart-title">
							<span>Top </span>
							<span v-if='customerChartData.datasets[0].data.length > 0'>{{ customerChartData.datasets[0].data.length }} </span>Cities</div>
						<div class="chart-empty" v-if='customerChartData.datasets[0].data.length === 0'>
							<i class="material-icons md-48">error_outline</i>
							<span class="ml-2">{{ $t('There is no data available') }}</span>
						</div>
						<div v-else>
							<customer-chart
								class="chart"
								:chartId="customerChartData.chartId"
								:options="customerChartOptions"
								:chart-data="customerChartData">
							</customer-chart>
							<a
								class="chart-see_more"
								v-if='customerChartData.datasets[0].data.length > 9'
								@click="showCities">
								{{ $t('See More') }}
							</a>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="box box-pie-chart text-center">
					<div class="chart-title mb-3">{{ $t('Tracking Statistic') }}</div>
					<tracking-statistic
						:data="trackingStats"
						@trackingStatisticSeeMore="showTrackingStats">
					</tracking-statistic>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Overviews from '@/components/Overviews.vue';
import TrackingStatistic from '@/components/TrackingStatistic.vue';
import FollowUpConversion from '@/components/FollowUpConversion.vue';
import CustomerChart from '@/components/charts/CustomerChart.vue';
import TransactionChart from '@/components/charts/TransactionChart.vue';

export default {
	name: 'SubmissionStats',
	components: {
		Overviews,
		TrackingStatistic,
		CustomerChart,
		TransactionChart,
		FollowUpConversion,
	},
	props: {
		overview: {
			type: Object,
		},
		overviewItems: {
			type: Object,
		},
		transactionChartData: {
			type: Object,
		},
		transactionChartOptions: {
			type: Object,
		},
		customerChartData: {
			type: Object,
		},
		customerChartOptions: {
			type: Object,
		},
		followUpStats: {
			type: Object,
		},
		trackingStats: {
		},
		capabilities: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		showCities() {
			this.$emit('show-cities');
		},
		showTrackingStats(stats) {
			this.$emit('show-tracking-stats', stats);
		},
	},
};
</script>
